export default __webpack_public_path__ + "static/media/search-icon.59826ad3.svg";